module.exports = __webpack_public_path__ + "img/plug-light.00f3acca.svg";